import { ConfigTypes } from 'src/AppState/ConfigState/types';

export const features: ConfigTypes = {
    /* A */
    anniversaryInfoShow: false,
    accountTradingCountryClub: false,
    accountTradingDragonCircle: false,
    accountTradingRewardZone: false,
    accountTradingTartanClub: false,
    affiliateIdPromoCode: false,
    activityTimeframe: false,

    /* B */
    betBuilderReferralSwitchShow: true,

    /* C */
    casinoProviders: {
        casino: ['leap', 'pragmatic', 'blueprint', 'relax', 'sg-digital'],
        'live-casino': ['pragmatic'],
        virtuals: ['pragmatic', 'leap'],
    },
    closureCodes: true,
    cmsHiddenTabs: ['headlineCarousel', 'promoCode'],
    complianceRestrictionSummary: false,
    contactPreferences: {
        preferences: ['email', 'sms', 'phone'],
        options: ['betting', 'casino'],
        newMarketing: true,
    },
    currencies: ['GBP', 'EUR', 'XTS'], // TODO: CONFIRM FOR LondonBet
    cpfProperties: false,
    casinoStoreEnabled: false,

    /* D */
    dashboardTab: false,
    decimalLength: 2,
    depositLimitType: 'rollingType',
    depositLimitCalculationTypeConfigurable: true,
    depositRestriction: true,
    deceased: false,

    /* E */
    externalId: false,

    /* F */
    configurationManagerUI: false,
    failedWithdrawalsFundsEnabled: true,
    footerContentDefault: {
        description_text: '#TOBEADDED', // TODO: ADD FOR LondonBet
        licence_number: '#TOBEADDED', // TODO: ADD FOR LondonBet
        licence_url: '#TOBEADDED', // TODO: ADD FOR LondonBet
        cookies_url: '#TOBEADDED', // TODO: ADD FOR LondonBet
        has_cookies: true,
    },
    footerLegalTextTab: true,
    fullNameProperties: false,

    /* H */
    hasNewMenu: true,
    hideDeleteImageButtonOnHomePageCarousel: false,
    hasXtremepush: false,

    /* G */
    gamprotect: false,
    gamstopNew: true,
    gamstopPpBlockedSuspendedActions: false,
    golfOnVirtuals: false,
    gtm: 'GTM-WMDP4WKS',

    /* I */
    isAffordability: true,
    isPEP: true,
    identity: true,
    idMission: false,
    isBoostedPriceAvailable: true,
    indexNow: null,

    /* L */
    languages: [
        {
            value: 'en',
            label: 'English',
        },
    ],

    /* O */
    operatorFullName: 'LondonBet',

    /* P */
    personalId: false,
    paymentSearchWalletAddress: false,
    pof: true,
    promotionHistoryEnabled: true,

    /* R */
    realityCheckLimitedType: false,
    reportDownloadOptions: ['Export to CSV'],
    redirectToNewBetTickerPage: false,
    redirectToNewCMSPage: false,
    reportsV2: false,
    redirectToNewTradingPage: false,
    showRingFencedFunds: true,

    /* M */
    markersOfHarm: true,
    mobilePrefixDisabled: false,
    dopplernegroPrefix: false,
    minDepositAmount: '1',
    minWithdrawAmount: '1',
    minManualAdjustmentAmount: '1',

    /* N */
    newPragmatic: true,
    newPofSrg: true,
    notificationSounds: {
        newChat: 'ding',
        newBetReferral: 'ding',
    },

    /* S */
    sourceOfFunds: true,
    srgEnabled: true,
    starEventsLabel: 'LondonBet Specials', // TODO: CONFIRM FOR LondonBet
    showBonusEngine: true,
    showNewCustomerSettings: false,
    showRABInputs: true,
    showBonusCreator: true,

    /* T */
    tableauDashboards: true,
    tagManagementTab: true,
    topEvents: false,

    /* U */
    useExtraPlacesForEvents: false,
    usePaymentFormForUniverse: {
        type: 'paysafe',
        apiKey: 'T1QtMzQ1NzYyOkItcDEtMC02N2VlNTg5OC0wLTMwMmMwMjE0MzRkZjFhNzQyYzhkZTgwMDQxZTJkNTRlOWMwMDYxM2ZmMWY3ZTY4ZDAyMTQ0ZmMxYzk4NDI3NmJkY2Q1NGZhMGZkYzgxYzJmZGMzNjQ3MDVmYzY2',
        environment: 'LIVE',
        cardAccounts: {
            GBP: '1003121652',
            EUR: '',
        },
        openBanking: null,
    },
    userTitleOptional: false,
    /* V */

    /* W */
    withdrawalsTabsShow: true,
    withdrawalStandardLimit: '5000',
    workbookView: {
        BackofficeReports: 'BackOfficeReports-LondonBet/DB-Casino',
        AccountBalances: 'AccountBalances-LondonBet/AccountBalances',
        CasinoDashboard: 'CasinoDashboard-LondonBet/CasinoMainDashboard',
        ComplianceDashboard: 'ComplianceDashboard-LondonBet/ComplianceMainDashboard',
        MarketingDashboard: 'MarketingDashboard-LondonBet/MarketingMainDashboard',
        ProfitAndLossKPIs: 'ProfitandLossKPIs-LondonBet/DailyKPI',
        RacecourseDashboard: 'Racecourse-LondonBet/RacecourseMediaGroupDashboard',
        TransactionsDashboard: 'TransactionsDashboard-LondonBet/TransactionsMainDashboard',
        RollingNetDeposits: 'RollingNetDeposits-LondonBet/RollingNetDeposits',
        PlatformOverview: 'Overview-LondonBet/Overview',
        AuditsCustomerLists: 'AuditCustomerLists-LondonBet/Deposits',
        BonusEngine: 'BonusEngine-LondonBet/CampaignLevel',
    },
};
